import { makeEditorModal } from '../Modal';
import { Editor, TinyMCE } from 'tinymce';
import { insertToEditor } from '../core/Utils';

declare let tinymce: TinyMCE;

interface LatexData {
    latex: string,
}

export function addLatex(editor:Editor){
    addLatexButton(editor);
    insertCommandLatex(editor);
}

function addLatexButton(editor: Editor){
    editor.ui.registry.addButton("latex", {
        text: "",
        tooltip: 'Latex einfügen',
        icon: "formel",
        onAction: () => {
            createLatexModal(editor);
        }
    })
}


function createLatexModal(editor: Editor){
    const content = '<div class="convert-latex">' +
    '<p>Hier kannst du Latex-Code eingeben.</p>' +
    '<textarea id="latex-code" placeholder="Hier Latex Code eingeben..." class="form-control" style="height: 200px;"></textarea>' +
    '</div>';
    const settings = {
        submitBtn: {
            text: "Einfügen",
            class: "add-latex",
        },
        faq: 20,
    }
    const onclick = (modal) => {
        const latex = modal.find("#latex-code").val();
        editor.execCommand("insertLatex", {latex:latex});
        return true;
    }
    const modal = makeEditorModal('create-latex', 'Latex Einfügen', content, settings, onclick);
    $("#latex-code").focus();
}

function insertCommandLatex(editor:Editor){
    editor.addCommand("insertLatex", (data:LatexData) => {
        const mml = MathJax.tex2mml( data.latex, {em:12, ex:6, display: false}).replace(/(\r\n|\n|\r)/gm, "")
        insertToEditor(mml, editor);
    })
}
